module.exports = __webpack_public_path__ + "img/company17.0b6a4efa.png";